import { useEffect, useState } from "react";
import styled from "styled-components";
import { Icons } from "../../icons";
import { FlexRowCenter } from "../Styles";

const Loader = () => {
  const [loadingCount, setLoadingCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingCount((prev) => prev + 1);
    }, 200);
    return () => clearInterval(interval);
  }, []);

  return (
    <LoadingContainer $loadingCount={loadingCount % 5}>
      <Icons.CircleLoader />
    </LoadingContainer>
  );
};

export default Loader;

export const LoadingContainer = styled(FlexRowCenter)<{
  $loadingCount: number;
}>`
  position: absolute;
  inset: 1px;
  backdrop-filter: blur(2px);
  border-radius: ${({ theme }) => theme.radius["radius-m"].value}rem;

  svg circle {
    &:first-child {
      stroke-opacity: ${({ $loadingCount }) =>
        $loadingCount > 1 ? "1" : "0.4"};
    }
    &:nth-child(2) {
      stroke-opacity: ${({ $loadingCount }) =>
        $loadingCount > 0 ? "1" : "0.4"};
    }
    &:nth-child(3) {
      stroke-opacity: ${({ $loadingCount }) =>
        $loadingCount > 3 ? "1" : "0.4"};
    }
    &:last-child {
      stroke-opacity: ${({ $loadingCount }) =>
        $loadingCount > 2 ? "1" : "0.4"};
    }
  }
`;
